<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-12 col-md-4">
        <el-form-item
          :label="L10n('name')"
          prop="name"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            :value="form.name"
            @input="form.name = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
      <div class="col-12 col-md-4">
        <el-form-item
          :label="L10n('email')"
          prop="email"
          :rules="getValidationRule('required,email')"
          class="material-style">
          <el-input
            :value="form.email"
            @input="form.email = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
      <div class="col-12 col-md-4">
        <el-form-item
          :label="L10n('division')"
          prop="divisionID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.divisionID"
            :data="dataSourceDivision.records"
            :isLoading="dataSourceDivision.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <view-more>
      <div class="row">
        <div class="col-12 col-md-4">
          <el-form-item
            :label="L10n('title')"
            prop="title"
            class="material-style">
            <el-input
              :value="form.title"
              @input="form.title = valueTrimLeft($event)"/>
          </el-form-item>
        </div>
        <div class="col-12 col-md-4">
          <el-form-item
            :label="L10n('phone')"
            prop="phone"
            class="material-style">
            <el-input
              :value="form.phone"
              @input="form.phone = valueTrimLeft($event)"/>
          </el-form-item>
        </div>
        <div class="col-12 col-md-4">
          <el-form-item
            :label="L10n('mobile')"
            prop="mobile"
            class="material-style">
            <el-input
              :value="form.mobile"
              @input="form.mobile = valueTrimLeft($event)"/>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <el-form-item
            :label="L10n('remark')"
            prop="remark"
            class="material-style">
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.remark"/>
          </el-form-item>
        </div>
      </div>
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormSelectPartNumber',
  mixins: [Form],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue')
  },
  computed: {
    dataSourceDivision () {
      return this.API('Divisions/GetAllDynamic?select=id,title')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  }
}
</script>
